/**
 * useIsRTL Hook
 *
 * Returns whether the current language is RTL.
 * Use this instead of checking `i18n.language === 'ar'` to support all RTL languages.
 */

import { useTranslation } from 'react-i18next'
import { isRTLLanguage } from '../utils/rtl'

/**
 * Hook to check if current language is RTL
 * @returns true if the current language is RTL (Arabic, Urdu, Hebrew, etc.)
 *
 * @example
 * const isRTL = useIsRTL()
 * return <div className={cn("flex", isRTL && "flex-row-reverse")}>...</div>
 */
export function useIsRTL(): boolean {
  const { i18n } = useTranslation()
  return isRTLLanguage(i18n.language)
}
